import PropTypes from 'prop-types'
import React, { Component } from 'react'

import ErrorView from '../src/pages/Error'


class Error extends Component {

  static getInitialProps({ res, err }) {
    return { error: 404, errorComponent: true }
  }

  render() {
    const { pageProps } = this.props

    return (<ErrorView {...pageProps} />)
  }

}

Error.propTypes = {
  // eslint-disable-next-line
  pageProps: PropTypes.object,
}

Error.defaultProps = {
  pageProps: {},
}

export default Error
